import { create } from 'zustand';
import type { AutosaveStatus } from '@/utils/autosaveStorage';

/** Separate from persisted data to avoid recursively triggering autosave. */
export const useAutosaveStatus = create<{ status: AutosaveStatus }>(() => ({
  status: 'unavailable',
}));
